export default function DefaultPlugin() {
  return [{
    getWidth: function getWidth() {
      return 200;
    },
    canDelete: function canDelete() {
      return true;
    },
    canEdit: function canEdit() {
      return true;
    },
    canSort: function canSort() {
      return false;
    },
    getSortOptions: function getSortOptions() {
      return [];
    },
    getFieldData: function getFieldData(_ref) {
      var field = _ref.field;
      return field.data;
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      return false;
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      return false;
    },
    renderColumnTypeOptions: function renderColumnTypeOptions(columnType, database, next) {
      return false;
    },
    renderField: function renderField(props, database, next) {
      // Default, so last chance to render the field without breaking
      return props.field.data.text || '';
    }
  }];
}